/**
 * Centralized facility definitions for BareMC.
 */

export const FACILITIES_LIST = [
  { id: 'beds', label: 'Sovesal / senge', shortLabel: 'Senge', category: 'overnight', icon: 'bed' },
  { id: 'tent', label: 'Overnatning / telt', shortLabel: 'Telt', category: 'overnight', icon: 'tent' },
  { id: 'caravan', label: 'Campingvogn-plads', shortLabel: 'Campingvogn', category: 'overnight', icon: 'caravan' },
  { id: 'clubhouse', label: 'Klubhus', shortLabel: 'Klubhus', category: 'basic', icon: 'home' },
  { id: 'parking', label: 'MC-parkering', shortLabel: 'Parkering', category: 'basic', icon: 'bike' },
  { id: 'shower', label: 'Bad & toilet', shortLabel: 'Bad', category: 'basic', icon: 'shower' },
  { id: 'handicap', label: 'Handicapvenlig', shortLabel: 'Handicap', category: 'basic', icon: 'accessibility' },
  { id: 'food', label: 'Mad / køkken', shortLabel: 'Mad', category: 'comfort', icon: 'utensils' },
  { id: 'grill', label: 'Grill / bålplads', shortLabel: 'Grill', category: 'comfort', icon: 'flame' },
  { id: 'wifi', label: 'WiFi', shortLabel: 'WiFi', category: 'comfort', icon: 'wifi' },
  { id: 'electricity', label: 'Strøm til gæster', shortLabel: 'Strøm', category: 'comfort', icon: 'zap' },
  { id: 'bar', label: 'Bar', shortLabel: 'Bar', category: 'comfort', icon: 'beer' },
];

export const FACILITIES_MAP = {};
FACILITIES_LIST.forEach(f => { FACILITIES_MAP[f.id] = f; });

export const OVERNIGHT_FACILITY_IDS = ['beds', 'tent', 'caravan'];

/**
 * Facility star rating (1-5): based on number of facilities
 */
export function getFacilityStarRating(facilities) {
  if (!facilities || facilities.length === 0) return 0;
  const count = facilities.length;
  if (count >= 10) return 5;
  if (count >= 7) return 4;
  if (count >= 5) return 3;
  if (count >= 3) return 2;
  return 1;
}

/**
 * Hospitality star rating (1-3): based on overnight + breakfast
 *   1 star  = Has overnight (paid)
 *   2 stars = Free overnight
 *   3 stars = Free overnight + free breakfast
 */
export function getHospitalityStarRating(facilities, overnightFree, breakfastIncluded, breakfastPrice) {
  if (!hasOvernight(facilities)) return 0;
  if (overnightFree && breakfastIncluded && (!breakfastPrice || breakfastPrice === 0)) return 3;
  if (overnightFree) return 2;
  return 1;
}

export function hasOvernight(facilities) {
  if (!facilities) return false;
  return facilities.some(f => OVERNIGHT_FACILITY_IDS.includes(f));
}
